import React from 'react'
import './SeoTop.css'
import seo4 from './../../../Assets/images/seo4.png'
import senogte from './seonogte.svg'
import {BsArrowLeftShort} from 'react-icons/bs'
import seoback from './../../../Assets/images/seoback.png'

export default function Seotop() {
  return (
    <section className='seotop'>
        <div className="seotop__conatiner">
            <section className="seotop__right">
                <img src={seo4} alt="" />
            </section>
            <section className='seotop__left'>
                <section className='seotop__left__top'>
                    <h1 className='seotop__left__top__title'>
                          مقام اول گوگل جایگاه شماست
                    </h1>
                    <h4 className='seotop__left__top__subtitle'>
                    لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ
                    </h4>
                    <p className='seotop__left__top__text'>
                    لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است
                    </p>
                    <div className="seotop__left__top__box">
                        <div className="seotop__left__top__box__inner">
                            <button className='seotop__left__top__box__inner__btn'>
                                همین حالا شروع کن
                            </button>
                            <p>درخواست مشاوره</p>
                        </div>
                    </div>
                </section>
                <section className='seotop__left__bottom'>
                
                    <div className="seotop__left__bottom__item">
                        <h3 className='seotop__left__bottom__item__title'>
                            مشاوره برندینگ
                        </h3>
                        <div className="fadeout">
                        <p className='seotop__left__bottom__item__text'>
                        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد کتابهای زیادی در شصت و سه درصد گذشته حال و آینده
                        </p>
                        </div>
                        <div className="seotop__left__bottom__item__bottom">
                            <div className="seotop__left__bottom__item__bottom__icon">
                                <BsArrowLeftShort />
                            </div>
                            <p className='seotop__left__bottom__item__bottom__text'>BRANDING ADVICE</p>
                        </div>
                    </div>

                    <div className="seotop__left__bottom__item">
                        <h3 className='seotop__left__bottom__item__title'>
                            مشاوره برندینگ
                        </h3>
                        <div className="fadeout">
                        <p className='seotop__left__bottom__item__text'>
                        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد کتابهای زیادی در شصت و سه درصد گذشته حال و آینده
                        </p>
                        </div>
                        <div className="seotop__left__bottom__item__bottom">
                            <div className="seotop__left__bottom__item__bottom__icon">
                                <BsArrowLeftShort />
                            </div>
                            <p className='seotop__left__bottom__item__bottom__text'>BRANDING ADVICE</p>
                        </div>
                    </div>

                    <div className="seotop__left__bottom__item">
                        <h3 className='seotop__left__bottom__item__title'>
                            مشاوره برندینگ
                        </h3>
                        <div className="fadeout">
                        <p className='seotop__left__bottom__item__text'>
                        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد کتابهای زیادی در شصت و سه درصد گذشته حال و آینده
                        </p>
                        </div>
                        <div className="seotop__left__bottom__item__bottom">
                            <div className="seotop__left__bottom__item__bottom__icon">
                                <BsArrowLeftShort />
                            </div>
                            <p className='seotop__left__bottom__item__bottom__text'>BRANDING ADVICE</p>
                        </div>
                    </div>

                    <div className="seotop__left__bottom__item">
                        <h3 className='seotop__left__bottom__item__title'>
                            مشاوره برندینگ
                        </h3>
                        <div className="fadeout">
                        <p className='seotop__left__bottom__item__text'>
                        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد کتابهای زیادی در شصت و سه درصد گذشته حال و آینده
                        </p>
                        </div>
                        <div className="seotop__left__bottom__item__bottom">
                            <div className="seotop__left__bottom__item__bottom__icon">
                                <BsArrowLeftShort />
                            </div>
                            <p className='seotop__left__bottom__item__bottom__text'>BRANDING ADVICE</p>
                        </div>
                    </div>

                    <div className="seotop__left__bottom__item">
                        <h3 className='seotop__left__bottom__item__title'>
                            مشاوره برندینگ
                        </h3>
                        <div className="fadeout">
                        <p className='seotop__left__bottom__item__text'>
                        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد کتابهای زیادی در شصت و سه درصد گذشته حال و آینده
                        </p>
                        </div>
                        <div className="seotop__left__bottom__item__bottom">
                            <div className="seotop__left__bottom__item__bottom__icon">
                                <BsArrowLeftShort />
                            </div>
                            <p className='seotop__left__bottom__item__bottom__text'>BRANDING ADVICE</p>
                        </div>
                    </div>

                    <div className="seotop__left__bottom__item">
                        <h3 className='seotop__left__bottom__item__title'>
                            مشاوره برندینگ
                        </h3>
                        <div className="fadeout">
                        <p className='seotop__left__bottom__item__text'>
                        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد کتابهای زیادی در شصت و سه درصد گذشته حال و آینده
                        </p>
                        </div>
                        <div className="seotop__left__bottom__item__bottom">
                            <div className="seotop__left__bottom__item__bottom__icon">
                                <BsArrowLeftShort />
                            </div>
                            <p className='seotop__left__bottom__item__bottom__text'>BRANDING ADVICE</p>
                        </div>
                    </div>
                </section>
            </section>


        </div>
        <div className="seotop__left__bottom__svg">
            <img src={seoback} alt="" />
        </div>
    </section>
  )
}
